import { deleteZona, getZonasPanel } from "../../services/ZonasServices";
import { ZonasContext } from "./ZonasContext"

export const ZonasState = ({ children }) => {
    const getZonasPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getZonasPanel(searchTerm,numPagina, filas);
        return res
    }

    const deleteZonaData = async (body) => {
        const res = await deleteZona(body)
        return res
    }
   
    return <ZonasContext.Provider value={{
        deleteZonaData,
        getZonasPanelData,
    }} >
        {children}
    </ZonasContext.Provider>
}